module.exports = require('./dist/input-slider.js');



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-input-slider/index.js
// module id = 612
// module chunks = 0